<script setup lang="ts">
import {
  SuggestionTypeSelector,
  SuggestionTypeSelectorSize,
  InfoIconPosition,
} from '@apps/main/new-desktop/modules/suggestionTypeSelector';
import type { SuggestionType } from '@apps/main/new-desktop/modules/suggestionTypeSelector';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

interface HotelSelectionListHeaderProps {
  hotelsTotal: number;
  suggestionType: SuggestionType;
}

const props = defineProps<HotelSelectionListHeaderProps>();

interface HotelSelectionListHeaderEmits {
  (eventName: 'suggestionTypeSelected', suggestionType: SuggestionType): void;
  (eventName: 'showWhyWeSuggest'): void;
}

const emit = defineEmits<HotelSelectionListHeaderEmits>();

const { t } = i18n.global;
</script>

<template>
  <div class="hotel-selection-list-header">
    <div class="hotels-total">
      {{ t('filter.hotelTypes.hotels', props.hotelsTotal) }} ({{
        props.hotelsTotal
      }})
    </div>
    <SuggestionTypeSelector
      font-variant="font-light"
      :suggestion-type="props.suggestionType"
      app-select-type="transparent"
      icon-position="right"
      :show-info-icon="InfoIconPosition.Outside"
      :size="SuggestionTypeSelectorSize.Small"
      @show-info="emit('showWhyWeSuggest')"
      @suggestion-type-selected="emit('suggestionTypeSelected', $event)"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .hotels-total {
    @include font-label-m-light;
    color: var(--color-neutral-70);
  }
}
</style>
